import { Control, Controller } from 'react-hook-form'

import { TextField } from '@mui/material'

import { VideoMainFormValues } from '../../videoMainForm.types'

type Props = {
  control: Control<VideoMainFormValues>
}

const MIN_DURATION = 0
const MAX_DURATION = 86400 // 24 часа

export const DurationController = ({ control }: Props) => {
  return (
    <Controller
      control={control}
      defaultValue={null}
      name={'durationInSeconds'}
      render={({ field, fieldState }) => {
        let helperText = ''

        if (fieldState.error) {
          if (fieldState.error.type === 'min') {
            helperText = `Минимальное значение — ${MIN_DURATION}`
          } else if (fieldState.error.type === 'max') {
            helperText = `Максимальное значение — ${MAX_DURATION} (24 часа)`
          } else if (fieldState.error.type === 'validate') {
            helperText = 'Введите целое число'
          }
        }

        return (
          <TextField
            error={!!fieldState.error}
            fullWidth
            helperText={helperText}
            inputProps={{ inputMode: 'numeric', min: MIN_DURATION, max: MAX_DURATION, step: 1 }}
            label={'Длительность (сек)'}
            name={field.name}
            onBlur={field.onBlur}
            onChange={event => {
              const rawValue = event.target.value

              if (rawValue === '') {
                field.onChange(null)

                return
              }

              const parsed = Number(rawValue)

              field.onChange(Number.isNaN(parsed) ? null : parsed)
            }}
            placeholder={'например, 480'}
            ref={field.ref}
            type={'number'}
            value={field.value ?? ''}
          />
        )
      }}
      rules={{
        min: MIN_DURATION,
        max: MAX_DURATION,
        validate: value => value === null || Number.isInteger(value),
      }}
    />
  )
}
